import http from '../../../utils/services/http'

export const update = (id, data) => {
  let url = `/api/updater/user/${id}`

  return http.post(url, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
export const aceitaTermos = (data = {}) => {
  let url = `/api/updater/acceptTerms`

  return http.post(url, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
